import axios from 'axios';
import { getAPIHost, getExpressAPIHost } from '../../utils';
import Split from '../split';

const uploadBulkChart = (formData) =>
    new Promise((resolve, reject) => {
        const useExpress = Split.getBooleanTreatment('use_express_migration_endpoints');
        const host = useExpress ? getExpressAPIHost() : getAPIHost();
        // Split-gate both host AND path: Express uses /users/upload-bulk-chart;
        // LoopBack uses the un-namespaced /upload-bulk-chart.
        const path = useExpress ? '/users/upload-bulk-chart' : '/upload-bulk-chart';
        axios
            .post(`${host}${path}`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then((response) => {
                resolve(response);
            })
            .catch(() => {
                reject(new Error('Unable to share file'));
            });
    });

export default uploadBulkChart;
